import { SupportingDocumentType } from '@barkibu/noma-commons';
import { CostLineDto } from './dtos/CostLineDto';
import { InvoiceDto } from './dtos/InvoiceDto';
import CostLine from '../../../domain/entities/CostLine';
import { ExternalReview } from '../../../domain/entities/ExternalReview';
import Invoice from '../../../domain/entities/Invoice';
import { SupportingDocument } from '../../../domain/entities/supporting-document';
import { DigitisationStatus } from '../../../domain/values/DigitisationStatus';

const parseDateSafe = (value: unknown): Date | undefined => {
    if (value == null) return undefined;
    const d = new Date(value as string | number);
    return isNaN(d.getTime()) ? undefined : d;
};

export const toDomain = (invoiceDto: InvoiceDto): Invoice => {
    return new Invoice({
        key: invoiceDto.key,
        date: parseDateSafe(invoiceDto.date),
        number: invoiceDto.number,
        taxIdNumber: invoiceDto.taxIdNumber,
        providerName: invoiceDto.providerName,
        discountInCents: invoiceDto.discountInCents,
        supportingDocument: new SupportingDocument({
            key: invoiceDto.supportingDocument.key,
            type: SupportingDocumentType[invoiceDto.supportingDocument.type as keyof typeof SupportingDocumentType],
            location: invoiceDto.supportingDocument.location,
            date: new Date(invoiceDto.supportingDocument.createdAt),
            deleted: false,
            isNewlyAddedByParent: invoiceDto.supportingDocument.newlyAddedByParent,
        }),
        costLines: invoiceDto.costLines.map(costLineDtoToDomain),
        digitisationStatus: DigitisationStatus[invoiceDto.digitisationStatus as keyof typeof DigitisationStatus],
        externalReview: invoiceDto.externalReview ? externalReviewDtoToDomain(invoiceDto.externalReview) : undefined,
        currency: invoiceDto.currency,
    });
};

const externalReviewDtoToDomain = (dto: NonNullable<InvoiceDto['externalReview']>): ExternalReview => ({
    source: dto.source,
    externalRevisionId: dto.externalRevisionId,
    appliedAt: new Date(dto.appliedAt),
});

const costLineDtoToDomain = (costLineDto: CostLineDto): CostLine => {
    return new CostLine({
        key: costLineDto.key,
        concept: costLineDto.concept,
        units: costLineDto.units,
        VAT: costLineDto.vat,
        priceInCents: costLineDto.priceInCents,
    });
};
